import { EnvironmentVariable } from './constants';

const keycloakConfig = {
  authServerUrl: EnvironmentVariable.AUTH_SERVER_URL,
  realm: EnvironmentVariable.AUTH_REALM,
  clientId: EnvironmentVariable.AUTH_CLIENT_ID,
};

export default keycloakConfig;
